import { c as _c } from "react/compiler-runtime";
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import UserPlanSkeleton from 'modules/profile/user-plan/components/user-plan-skeleton';
import UserPlanTable from 'modules/profile/user-plan/components/user-plan-table';
import { UserPlanLoco } from 'modules/profile/user-plan/constants/user-plan-loco';
import { useUserPlan } from 'modules/profile/user-plan/hooks/use-user-plan';
import { useUserSettings } from 'modules/profile/user-settings/hooks/use-user-settings';
import { NextPage } from 'next';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const UserPlan: NextPage = () => {
  const $ = _c(10);
  const {
    t
  } = useLocoTranslation();
  const {
    userPlanData
  } = useUserPlan();
  const {
    userSettings
  } = useUserSettings();
  let t0;
  if ($[0] !== t) {
    t0 = t(settingsMenuLocoKeys.my_plan);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = [{
      caption: t0,
      isStatic: true
    }];
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== userPlanData || $[5] !== userSettings) {
    t2 = userPlanData && userSettings ? <UserPlanTable currentUserPlanData={userPlanData} showWithTax={!userSettings.user?.taxNumber} /> : <UserPlanSkeleton />;
    $[4] = userPlanData;
    $[5] = userSettings;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <SettingsLayout needSave={false} titles={t1}>{t2}</SettingsLayout>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export const getServerSideProps = getBaseServerSideProps(UserPlanLoco, 'global.settings');
export default UserPlan;